import { Component, OnInit } from "@angular/core";
import { AuthService } from "src/app/core/services/auth/auth.service";

@Component({
  selector: "app-create-contact-list",
  templateUrl: "./create-contact-list.component.html",
  styleUrl: "./create-contact-list.component.scss",
})
export class CreateContactListComponent implements OnInit {
  breadCrumbItems!: Array<{}>;

  podeEditar = false;
  podeVer = false;

  constructor(private authService: AuthService) {}
  
  ngOnInit(): void {
    this.breadCrumbItems = [
      { label: "Contatos" },
      { label: "Gerar contato", active: true },
    ];

    this.permissaoAdicionarUsuario();
  }

  permissaoAdicionarUsuario(): void {
    this.podeEditar = this.authService.verificarPermissao('Call_Gerar_Contatos', 'Editar')
    this.podeVer = this.podeEditar;
  }
}
